module.exports = __webpack_public_path__ + "media/icon_transaction/bird_3-c3502a97.png";